<template>
  <div class="first-layer-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'error_message_list'}" class="float-left mr-1 main-link">{{$t('error_message.error_message')}}</router-link>
                  / {{(uuid === 'create') ? $t('error_message.new') : $t('error_message.error_message_update')}}
                </h3>
              </strong>
            </div>

            <div class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('error_message.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0"/>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('error_message.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <b-form-group v-bind:label="$t('error_message.service')" :label-cols="2" :horizontal="true">
                      <b-form-select v-model="item.service" v-bind:value="item.service"
                                     :options="services"
                                     v-bind:placeholder="$t('error_message.service')">
                      </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group v-bind:label="$t('error_message.error_code')" :label-cols="2" :horizontal="true">
                    <b-form-input
                            class="form-control border-radius-4px"
                            v-model="item.error_code"
                            :state="!$v.item.error_code.$invalid"
                            :aria-describedby="'error-code-feedback'"
                    />
                    <b-form-invalid-feedback :id="'error-code-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('error_message.error_message')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-textarea
                                    :name="`error_message[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="item.error_message[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                                    rows="5"
                      ></b-form-textarea>
                    </div>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <div class="back-button">
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.push({name: 'error_message', query: {rollback: 1}})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              </div>
              <div class="btn-save">
                <button type="button" class=" pull-right btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveErrorMessage()" :disabled="checkSubmit() "> {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'

  let vm = null

  export default {
    name: 'ErrorMessageForm',
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
      cSwitch
    },
    data: function () {
      return {
        item: {
          uuid: '',
          service: '',
          error_message: {},
          error_code: '',
        },
        services: [],
        basicInformationStatus: true,
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        error_code: {
          required
        },
      }
    },
    computed: {},
    methods: {
      checkSubmit: function () {
        let validateName = false
        let form = vm.$v.item.$invalid
        return form || validateName
      },
      saveErrorMessage () {
        let data = JSON.parse(JSON.stringify(vm.item))
        if (vm.item.uuid === '' || vm.item.uuid === 'create') {
          vm.axios.tenant.createErrorMessage(data, function (response) {
            vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
          }, function () {
          })
        } else {
          vm.axios.tenant.updateErrorMessage(data, function (response) {
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          }, function () {
          })
        }
      },
      /**
       * get list categories for select box
       */
      getDetailErrorMessage () {
        vm.axios.tenant.getDetailErrorMessage(vm.uuid, function (response) {
          let item = response.data.data.item
          if (item.error_message == null || item.error_message.length == 0) {
            item.error_message = {'ja': '', 'en': ''}
          }

          vm.item = item
          this.$forceUpdate()
        })
      },

      /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
    },
    created: function () {
      vm = this
    },
    updated: function () {
    },
    mounted: function () {
      if (vm.services.length > 0) {
        if (vm.uuid !== 'create' && vm.uuid !== undefined) {
          vm.getDetailErrorMessage()
        }
      } else {
        vm.axios.tenant.getListErrorService('', function (response) {
          for (let i in response.data.data.items) {
            vm.services.push({text: response.data.data.items[i].service_name, value: response.data.data.items[i].service_name})
          }
          if (vm.uuid !== 'create' && vm.uuid !== undefined) {
            vm.getDetailErrorMessage()
          }
        })
      }
    }
  }
</script>

<style scoped>

  .back-button {
    padding-left: 25px;
    width: 95px;
    float: left;
  }

  .first-layer-form .switch.switch-icon {
    margin-top: 5px;
  }

  .first-layer-form .header-custom-switch {
    margin-top: 5px;
    margin-bottom: 0;
  }

  .first-layer-form .header-custom-switch .col-form-label {
    text-align: right;
  }

  .first-layer-form .header-custom-switch .uppercase {
    display: inline-flex;
  }

  .first-layer-form .btn-save {
    float: right !important;
    padding-right: 22px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }

  /*END Form Wizard*/
</style>

<style>

  .preview-image {
    width: 100%;
  }

  .first-layer-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .first-layer-form div.header,
  .first-layer-form .header .card-header {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .close-btn .fa-angle-right {
    margin-right: -4px;
  }

  .close-btn .fa-angle-left {
    margin-left: -4px;
  }

  .first-layer-form .btn-primary .fa {
    font-size: 20px;
  }

  .first-layer-form .btn-primary {
    color: #0091ff;
    background-color: transparent;
  }

  .first-layer-form .btn-primary:hover {
    color: #0091ff;
    background-color: transparent;
  }

  .pt-05 {
    padding: 0.5rem;
  }

  .pb-15 {
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/error-message/BaseForm.vue